// extracted by mini-css-extract-plugin
export default {"Portal":"PipelineItemPortal_Portal__UNWjv","PortalContent":"PipelineItemPortal_PortalContent__80S7l","Text":"PipelineItemPortal_Text__-2Nlz"};